import queryString from 'query-string';
import { path } from 'ramda';
import { call, put, take, takeLatest } from 'redux-saga/effects';

import { loginWithToken } from 'modules/auth/login/data/sagas';
import { initTwoFactorAuthentication } from 'modules/auth/twoFactorAuthentication/data/actions';

import { setPasswordDetails } from 'services/api';
import authService from 'services/authService';

import { PAGE_REQUEST } from 'store/app/types';

import history from 'utils/browserHistory';

import { types, setPassword } from './actions';

export function* initSetPassword({ match }) {
  const token = path(['params', 'token'], match);
  return yield call(setPasswordDetails, token);
}

function* watchSetPassword(action) {
  let e = null;
  try {
    const { key, data } = action.payload;
    // endpoint either returns token or isTwoFactorAuthRequired, so one of them will be null while the other isn't
    const { username, token, isTwoFactorAuthRequired } = yield call(
      authService.setPassword,
      key,
      data,
    );
    const next = queryString.parse(window.location.search).next;
    const nextUrl = decodeURIComponent(next || '/parts');
    if (token) {
      yield call(loginWithToken, token, nextUrl);
      yield put(setPassword.success());
    } else if (isTwoFactorAuthRequired) {
      history.push('/authenticate');
      const action = yield take(PAGE_REQUEST);
      if (action.payload.location?.pathname === '/authenticate') {
        yield put(
          initTwoFactorAuthentication({
            username,
            password: data.password,
            nextUrl,
          }),
        );
      }
    }
  } catch (error) {
    yield put(setPassword.error((e = error)));
  }
  action.payload.cb(e);
}

export default function* root() {
  yield takeLatest(types.SET_PASSWORD_REQUEST, watchSetPassword);
}
